import React, { useRef, useContext } from "react"
// import PropTypes from 'prop-types';
import ModalConfig from "components/Stacker/config/ModalConfig"
import ModalGeneric from "components/Stacker/components/ModalGeneric/ModalGeneric"

import queryString from "query-string"
import { useLocation } from "react-router"
import { StackerContext } from "components/DYStackers/StackerContext"
import { useI18nContext } from "i18n/i18n-react"
import { getDYArea } from "stackerConfig"

// import './EmailItemModal.scss';

function ShareModal(props) {
  const location = useLocation()
  const shareInputRef = useRef()
  const stackerContext = useContext(StackerContext)
  const { LL } = useI18nContext()

  const onShareButtonClick = () => {
    shareInputRef.current.select()
    shareInputRef.current.setSelectionRange(0, 99999)
    document.execCommand("copy")
  }

  const onAfterModalOpen = () => {
    const stacker = stackerContext.getInstance()
    const queryObj = queryString.parse(location.search, { decode: true })
    const addedStack = Array.isArray(queryObj.products)
      ? queryObj.products
      : [queryObj.products]
    stacker.onShareThisClicked({
      shareLink: location.href,
      products: addedStack,
    })
  }

  return (
    <ModalGeneric
      name={ModalConfig.MODAL_STACKER_SHARE}
      standard
      onAfterOpen={onAfterModalOpen}
    >
      <div className="stacker-modal stacker-modal-share text-center">
        <h5 className="linotype-didot-font mb-2">
          {LL[getDYArea()].shareThis()}
        </h5>
        <p>{LL[getDYArea()].copyDescription()}</p>
        <input
          className="d-block mx-auto mb-2"
          readOnly
          ref={shareInputRef}
          value={window.location.href}
          type="text"
        />
        <button
          className="btn btn-text d-block mx-auto"
          onClick={onShareButtonClick}
        >
          {LL[getDYArea()].copyCTA()}
        </button>
      </div>
    </ModalGeneric>
  )
}

export default ShareModal
